import { call, put, takeLatest } from 'redux-saga/effects';

import * as deviceNavApi from 'src/service/api/deviceNav';
import * as deviceNavActions from './action';

export function * deviceNavRoot () {
  yield takeLatest(deviceNavActions.FETCH_DEVICE_NAV, fetchNav);
}

function * fetchNav (action) {
  try {
    const nav = yield call(deviceNavApi.getDeviceNav, action, { tab: action.tab, selectedFilters: action.selectedFilters });
    yield put(deviceNavActions.fetchDeviceNavSuccess(nav));
  } catch (err) {
    yield put(deviceNavActions.fetchDeviceNavFailed(err));
  }
}
